<template>
  <div class="product-page">
    <div class="card">
      <h1>{{campaign.title}}</h1>
      <p>{{campaign.description}}</p>
      <div class="amount">
        <span class="amount__qty">
          Aantal: {{ order.quantity }}
          <span v-if="campaign.quantity_max > 1" class="amount__qty__change">
            (<a href="#sadfsadfs" @click="change_qty">wijzig</a>)
          </span>
        </span>
        <span class="amount__price">{{campaign_price}}</span>
      </div>
      <div class="selected">
        Geselecteerd
      </div>
    </div>
    <div v-if="campaign.offers.length > 0" class="extra-products">
      <p class="sub-title">Misschien ook interessant</p>
      <div class="product"
           v-for="offer in campaign.offers"
           @click="select_offer(offer)"
           :key="offer.id">
        <div
          class="image-container"
          :style="`background-image: url('${axios.defaults.baseURL}${offer.image}')`">
        </div>
        <div class="information">
          <h2 class="product__title">{{offer.title}}</h2>
        </div>
        <div class="c-checkmark c-checkmark-no-text">
          <label class="container">
            <span v-if="offer.selected" class="checkmark">&#x2713;</span>
            <span v-else class="checkbox"></span>
          </label>
        </div>
        <div class="product__qty" v-if="offer.selected">
          Aantal: {{ offer.quantity }}
          <span class="product__qty__change" v-if="offer.quantity_max > 1">
            (<a @click="change_offer_qty($event, offer)" href="#">wijzig</a>)
          </span>
        </div>
        <div class="product__price">
          {{ offer_price(offer) }}
        </div>
      </div>
    </div>
    <bottom-button state="payment" :amount="amount" @clicked="submit"/>
  </div>
</template>

<script>
import BottomButton from '@/components/Bottom-Button.vue';

export default {
  name: 'Product',
  components: {
    BottomButton,
  },
  computed: {
    campaign() {
      return this.$store.getters['application/getCampaign'];
    },
    order() {
      return this.$store.getters['application/getOrder'];
    },
    campaign_price() {
      return this.price(this.campaign.price_incl_vat * this.order.quantity);
    },
    amount() {
      return this.$store.getters['application/getOrderPrice'];
    },
  },
  methods: {
    change_offer_qty(e, offer) {
      e.preventDefault();
      e.stopPropagation();

      this.prompt(`Voer het gewenste aantal in (maximaal ${offer.quantity_max}):`, offer.quantity)
        .then((quantity) => {
          offer.quantity = Math.min(offer.quantity_max, quantity); // eslint-disable-line
          this.$store.dispatch('application/selectOffer', offer);
        })
        .catch((error) => {
          if (error) {
            this.change_offer_qty(e, offer);
          }
        });
    },
    change_qty(e) {
      e.preventDefault();
      e.stopPropagation();

      this.prompt(`Voer het gewenste aantal in (maximaal ${this.campaign.quantity_max}):`, this.order.quantity)
        .then((quantity) => {
          this.order.quantity = Math.min(this.campaign.quantity_max, quantity); // eslint-disable-line
          this.$store.dispatch('application/updateOrder', this.order);
        })
        .catch((error) => {
          if (error) {
            this.change_qty(e);
          }
        });
    },
    prompt(msg, def) {
      return new Promise((resolve, reject) => {
        const quantity = prompt(msg, def); // eslint-disable-line no-alert
        if (!quantity) {
          return reject();
        }

        if (!/^\+?\d+$/.test(quantity)) {
          alert('Voer een nummer in a.u.b.'); // eslint-disable-line no-alert
          return reject(new TypeError('Input is not a number'));
        }

        return resolve(quantity);
      });
    },
    submit() {
      if (!this.campaign.requires_address) {
        this.$store.dispatch('application/postOrder', true);
      } else {
        this.$router.push({ name: 'details' });
      }
    },
    select_offer(offer) {
      if (!offer.selected) {
        offer.selected = true; // eslint-disable-line
        this.$store.dispatch('application/selectOffer', offer);
      } else {
        offer.selected = false; // eslint-disable-line
        this.$store.dispatch('application/removeOffer', offer);
      }
    },
    offer_price(offer) {
      const qty = offer.quantity || offer.quantity_default || 1;
      return this.price(offer.price_incl_vat * qty);
    },
    price(price) {
      return (price / 100).toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      });
    },
  },
};
</script>

<style lang="scss">
  @import '@/assets/css/colors.scss';

  .product-page {
    > .card {
      text-align: left;
      min-height: 0;
    }
    table {
      text-align: left;
      th {
        padding-right: 10px;
      }
    }
    .amount {
      padding: 15px 0 10px 0;
      width: 100%;
      line-height: 35px;
      .amount__price {
        text-align: center;
        font-size: 20pt;
        float: right;
      }
      .amount__qty__change {
        font-size: .8em;

        a {
          color: $secondary-dark;
        }
      }
    }
    .selected {
      position: relative;
      background-color: $secondary-dark;
      padding: 15px;
      text-align: center;
      color: $white;
      font-weight: 900;
    }
    .selected:before {
      content: '\2713';
      position: absolute;
      left: 20px;
    }
    .extra-products {
      width: 90%;
      margin: 20px auto;
      .sub-title {
        text-transform: uppercase;
        color: $white;
        font-weight: bold;
      }
      .product {
        border-radius: 4px;
        background-color: $white;
        min-height: 80px;
        margin-bottom: 15px;
        position: relative;

        .product__title {
          font-size: 1em;
        }

        .product__qty {
          font-size: 0.8em;
          position: absolute;
          bottom: 10px;
          left: 80px;

          .product__qty__change {
            a {
              color: $secondary-dark;
            }
          }
        }

        .image-container {
          background-size: cover;
          background-position: center;
          width: 60px;
          height: 60px;
          margin: 10px;
          float: left;
          img {
          }
        }
        .information {
          padding-top: 10px;
          p {
            margin: 0;
          }
        }
        .product__price,
        .c-checkmark {
          position: absolute;
          top: 0;
          right: 10px;
        }
        .product__price {
          top: auto;
          bottom: 10px;
        }

        .c-checkmark-no-text {
          width: 25px;
        }
      }
    }
  }
</style>
